import { Middleware, Action, AnyAction } from 'redux';
import { metaData } from 'store/appShell/metaData';
import { EventMap, EventDefinition } from './event';

const actionEvents: { [key: string]: EventMap } = {
  metaData
};

const flatEvents = (eventsMap: { [key: string]: EventMap }, type: string) =>
  Object.keys(eventsMap).reduce<EventDefinition[]>(
    (acc, key) => acc.concat(matchEvents(eventsMap[key], type)),
    []
  );
const matchEvents = (events: EventMap, type: string): EventDefinition[] =>
  Object.keys(events)
    .filter(event => event === type)
    .map(key => events[key]);

export function createMiddleware<S>(): Middleware<unknown, S> {
  const getEvents = (action: Action) => flatEvents(actionEvents, action.type);
  return store => next => (action: AnyAction) => {
    const prevState = store.getState();
    const result = next(action);
    const nextState = store.getState();
    getEvents(action).forEach(event => event(action, prevState, nextState));

    return result;
  };
}
